import { html } from "common-tags"

export function parseAtom(
  description: string,
  tabTrigger: string,
  snippet: string
) {
  return html`
    '${description}': 'prefix': '${tabTrigger}' 'body': """ ${snippet} """
  `
}
